import { FunctionComponent } from 'react';

// Components
import Image from '@Components/Utils/Image';

// Utils
import classnames from 'classnames';

// Styles
import styles from './EmptySchedule.module.scss';
import Anchor from '@Components/Utils/Anchor';

interface EmptyScheduleProps {
    href?: string;
    title?: string;
    btnText?: string;
    className?: string;
    description?: string;
}

const EmptySchedule: FunctionComponent<EmptyScheduleProps> = (props) => {
    const className = classnames([styles.wrapper, props.className]);
    return (
        <div className={className}>
            <div className={styles.body}>
                <div className={styles.empty_schedule}>
                    <Image className={styles.icon_empty} src="/assets/navbar/schedule.png" />
                    {props.title && <span className={styles.item_title}>{props.title}</span>}
                    {props.description && <span className={styles.item_description}>{props.description}</span>}
                    <Anchor href={props.href} className={styles.btn_booking}>
                        {props.btnText}
                    </Anchor>
                </div>
            </div>
        </div>
    );
};

EmptySchedule.defaultProps = {
    href: '',
    title: '',
    btnText: '',
    className: '',
    description: '',
};

export default EmptySchedule;
